<!--
  라이선스 만료 팝업

  @since 2018-12-11
  @author 송영근
-->

<template>
  <layout-popup :confirmEvt="confirm"
                ref="licenseExpiredPopup"
                @hide="onHide"
                :titleName="$t('cmn.notification')"
                :no-route-dismiss="true"
                :content-css="{minWidth: '570px', minHeight: '355px'}"
                :footerBtn="['confirm']">

    <div class="content-group">
      <div class="contents-row">
        <div class="portlet">
          <div class="contents-row">
            <table class="bs-table table-bordered-none">
              <colgroup>
                <col width="20%"/>
                <col width="auto"/>
              </colgroup>
              <tbody>
              <tr>
                <td style="vertical-align:middle !important;">
                  <div class="inline-group">
                    <p class="ico-error"></p>
                  </div>
                </td>
                <td style="vertical-align:middle !important;">
                  <div class="inline-group marT10">
                    <p v-if="veType() === 0 || ((uiData.system.ve_volume.code === 0 || uiData.system.ve_volume.code === 999) && licenseExpiredDay <= 90)">{{ licenseExpiredDay > 0 ? $tc('msg.notiMsgLicenseExpired1', 2, {day: licenseExpiredDay}) : $tc('msg.notiMsgLicenseExpired1', 1) }}</p>
                    <p v-else>{{ licenseVolumeMessage.desc }}</p>
                    <!--TAMS 제외-->
                    <!--<p>{{ $tc('msg.notiMsgLicenseExpired2', 0) }}</p>-->
                    <p>{{ $tc('msg.notiMsgLicenseExpired2', 1) }}</p>
                    <p>{{ $tc('msg.notiMsgLicenseExpired2', 2) }}</p>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <hr class="portlet-bottom-hr"/>
                  <div class="inline-group">
                    <q-checkbox v-model="denyMsg" class="bs bs-q-checkbox bs-q-checkbox-default" :label="this.$t('msg.denyMsgLicenseExpired')"></q-checkbox>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <div class="inline-group">
                    <q-select v-model="denyMsgTerm" :disable="!denyMsg" :options="denyMsgTermList" class="bs bs-q-select bs-q-select-default" style="width: 100px;"></q-select>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </layout-popup>
</template>

<script>
  import LayoutPopup from '~/components/popUp/LayoutModalPopUp'

  // 스토어 헬퍼
  import {createNamespacedHelpers} from 'vuex'

  // 스토어 헬퍼 메서드
  const commonHelper = createNamespacedHelpers('common/common')

  export default {
    name: 'LicenseExpiredPopUp',
    components: {
      LayoutPopup
    },
    directives: {},
    mixins: [],
    props: {},
    data () {
      return {
        denyMsg: true,
        denyMsgTerm: 1,
        denyMsgTermList: [
          {
            label: `1 ${this.$tc('cmn.day')}`,
            value: 1
          }, {
            label: `7 ${this.$tc('cmn.day')}`,
            value: 7
          }, {
            label: `30 ${this.$tc('cmn.day')}`,
            value: 30
          }
        ],
        licenseExpiredDay: 30,
        licenseVolume: [
          {
            code: 0,
            desc: `${this.$tc('msg.volume_license_message_0_succeed')}`
          },
          {
            code: 1,
            desc: `${this.$tc('msg.volume_license_message_1_expired')}`
          },
          {
            code: 2,
            desc: `${this.$tc('msg.volume_license_message_2_diff')}`
          },
          {
            code: 3,
            desc: `${this.$tc('msg.volume_license_message_3_notexistVolume')}`
          },
          {
            code: 4,
            desc: `${this.$tc('msg.volume_license_message_4_maxexceedVolume')}`
          },
          {
            code: 5,
            desc: `${this.$tc('msg.volume_license_message_5_duplicatedUUID')}`
          },
          {
            code: 999,
            desc: `${this.$tc('msg.volume_license_message_999_requestApiError')}`
          }
        ],
        licenseVolumeMessage: {}
      }
    },
    computed: {
      ...commonHelper.mapState({
        systemIp: state => state.uiData.system.ip,
        uiData: state => state.uiData
      })
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {},
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {},
    destroyed () {},
    errorCaptured () {},
    methods: {
      getCookie (cname) {
        let name = cname + '='
        let ca = document.cookie.split(';')
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i]
          while (c.charAt(0) === ' ') {
            c = c.substring(1)
          }
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length)
          }
        }
        return ''
      },
      setCookie () {
        let d = new Date()
        d.setTime(d.getTime() + (this.denyMsgTerm * 24 * 60 * 60 * 1000))
        document.cookie = `${this.systemIp}=${this.denyMsgTerm};expires=${d.toUTCString()};path=/`
      },
      veType () {
        const veType = _.get(this.uiData, ['system', 've_type'], 0)
        return veType
      },
      show (licenseExpiredDay) {
        // ve모드 라이선스 볼륨 조회
        if (this.uiData.system.ve_type > 0) {
          if (_.isEmpty(this.uiData.system.ve_volume)) {
            this.licenseVolumeMessage.desc = this.$tc('msg.volume_license_message_1_expired')
          } else {
            this.licenseVolumeMessage = this.licenseVolume.find((element) => element['code'] === this.uiData.system.ve_volume.code)
          }
        }
        this.licenseExpiredDay = licenseExpiredDay

        let cookieDenyMsgTerm = this.getCookie(this.systemIp)
        if (!cookieDenyMsgTerm) {
          // 처음부터 denyMsg가 false일 경우 q-select Disable이 정상적으로 동작하지 않음 (true -> false로)
          this.denyMsg = false
          this.$refs.licenseExpiredPopup.show()
        }
      },
      onHide () {
        this.$emit('hide')
      },
      confirm () {
        if (this.denyMsg) {
          this.setCookie()
        }
        this.$refs.licenseExpiredPopup.hide()
      }
    },
    watch: {}
  }
</script>

<style scoped>
</style>
